@if (points().length) {
  <span class="f-body-s f-medium">
    {{ 'labels.reason' | translate }}:
    {{ `${I18N}.unassignedPoints.${translateKey()}` | translate }}
  </span>

  @for (point of points(); track point) {
    <div class="point {{ getIsDedicatedPointClass(points(), point, $index) }}">
      @if (isFirstPointOfOrder(points(), point, $index)) {
        <div class="header f-body-s">
          <span>
            @let label = getOrderLabel(point);
            {{ label.type }} ·

            <onyx-link
              color="dark-gray"
              font="f-body-s"
              (click)="openOrderModal(point.order?.uuid ?? null)"
            >
              {{ label.identifier }}
            </onyx-link>
          </span>
        </div>
      }

      <app-route-point
        [point]="point"
        variant="preview"
        previewColor="gray"
        [forceIcons]="true"
        [interactivePreview]="true"
        [markerColor]="identifierColor()"
        [markerSize]="24"
      ></app-route-point>
    </div>
  }
}
